import { useQuery } from 'react-query';

import { workScheduleQueryKeys } from './queryKeys';
import { fetchWorkScheduleServiceNames } from './workScheduleApi';

export const useWorkScheduleServiceNamesQuery = ({ companyId }, options) =>
  useQuery(
    workScheduleQueryKeys.serviceNames(companyId),
    () => fetchWorkScheduleServiceNames({ companyId }),
    {
      enabled: Boolean(companyId),
      ...options,
    }
  );
